import React from 'react';
import { Link } from 'react-router';

const BuyNowOption = (props) => (
  <p className="text-center margin-bottom">
    Need more?
    {' '}
    <Link to="/buy">Buy now</Link>
  </p>
);

export default BuyNowOption;



// WEBPACK FOOTER //
// ./src/components/Dashboard/BuyNowOption.js